import { BaseRich } from '../BaseRich';

class RichAngleBoxDraw extends BaseRich {

}

export {
  RichAngleBoxDraw,
};
